import { render, staticRenderFns } from "./AnimatedIconWarning.vue?vue&type=template&id=52133942&scoped=true&"
import script from "./AnimatedIconWarning.vue?vue&type=script&lang=js&"
export * from "./AnimatedIconWarning.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIconWarning.vue?vue&type=style&index=0&id=52133942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52133942",
  null
  
)

export default component.exports